import request from '@/utils/request'

// 获取商品分类
export function brandList(data) {
  return request({
    url: '/proxyApi/findBrandList',
    method: 'post',
    data
  })
}
// 获取商品列表
export function shopList(data) {
  return request({
    url: '/proxyApi/findSpuList',
    method: 'post',
    data,
  })
}
// 添加购物车
export function addCategory(data) {
  return request({
    url: '/proxyApi/addCart',
    method: 'post',
    data,
  })
}
